/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-03-03T15:03:01-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-19T15:14:15-07:00
*/



import React, { Component } from 'react';
import glamorous from 'glamorous';
import { dimensions, borders, truncate } from '../../../style';
import { tsYears } from '../../../common';
import { Link } from 'react-router';
import Button from '../../blocks/Button'
import ButtonSet from '../../blocks/ButtonSet'
import Modal from '../../common/Modal'
import { MenuList, MenuListItem } from '../../blocks/MenuList'

const MsgHeaderContainer = glamorous.div({
  display: 'flex',
  borderBottom: borders.DEFAULT,
  padding: '6px 14px',

  [dimensions.SCREEN_MIN_SM]: {
    padding: '12px 14px'
  }
});

const BackButton = glamorous.div({
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center'
});

const TitleLink = glamorous(Link)({
  alignItems: 'center',
  justifyContent: 'center',
  flex: '1 1 0%',
  display: 'inline-flex',
  minWidth: 0
});

const Title = glamorous.div({
  alignItems: 'center',
  justifyContent: 'center',
  flex: '1 1 0%',
  display: 'inline-flex',
  minWidth: 0
});

const Label = glamorous.span({
  [dimensions.SCREEN_MAX_SM]: {
    display: 'none'
  }
});

const Actions = glamorous.div({
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center'
});

const HeaderName = glamorous.div({
  ...truncate
});

const UserAvatar = glamorous.div({
  flexShrink: 0,
  width: 38,
  height: 38,
  overflow: 'hidden',
  borderRadius: 38,
  marginRight: 12
});

const AvatarImg = glamorous.img({
  width: '100%',
  height: '100%'
});

const UserName = glamorous.div({
  fontSize: 20,
  fontWeight: '300'
});

const UserMeta = glamorous.div({
  ...truncate
});

const HeaderTitle = (props) => {
  const {
    isAdmin,
    children,
    to
  } = props;

  if(isAdmin) {
    return (
      <Title>
        {children}
      </Title>
    );
  } else {
    return (
      <TitleLink to={to}>
        {children}
      </TitleLink>
    );
  }
}

class MsgHeader extends Component {
  renderMoreModal = () => {
    return(
      <Modal linkText={<svg className="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"/></svg>}>
        <MenuList>
          <MenuListItem centered>
            <Button fit to={`/report/${this.props.username}`}>Report User</Button>
          </MenuListItem>
          <MenuListItem centered>
            <Button fit to="" onClick={() => {this.props.toggleBlock(this.props.username)}}>
              Block User
            </Button>
          </MenuListItem>
          <MenuListItem centered>
            <Button to={`/messages/${this.props.username}#delete`} fit>Delete Message</Button>
          </MenuListItem>
        </MenuList>
      </Modal>
    );
  }

  render() {
    let { username, profile, isAdmin } = this.props;

    return (
      <MsgHeaderContainer>
        <BackButton>
          <Link to="/mail">
            <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style={{verticalAlign: 'middle'}}><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
            <Label>&nbsp;Back to Messages</Label>
          </Link>
        </BackButton>
        <HeaderTitle to={`/~${username}`} isAdmin={isAdmin}>
          <UserAvatar>
            <AvatarImg src={profile.avatar.data.urls.profile} alt="profile" />
          </UserAvatar>
          <HeaderName>
            <UserName>{username}</UserName>
            <UserMeta>{profile.age} ･ {profile.city}, {profile.country}</UserMeta>
          </HeaderName>
        </HeaderTitle>

        {
          !isAdmin &&
          <Actions>
            {this.renderMoreModal()}
          </Actions>
        }

        {window.location.hash ? <Modal openStatus={true} title="Are you sure you want to delete this message?"
        yesCallback={() => { this.props.deleteMail(username) }} /> : ''}

      </MsgHeaderContainer>
    );
  }
}


export default MsgHeader;



// WEBPACK FOOTER //
// ./src/components/pages/Mail/MsgHeader.jsx